// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal-dialog {
  max-width: 700px !important;
}

#striped-light .card {
  margin: 0;
}

form .col-form-label {
  font-weight: 400;
  text-transform: none;
  letter-spacing: normal;
}

.table thead th {
  background: transparent;
  color: #586562;
  border-top: none;
}
.table tbody tr:hover {
  background: #e4f1fa;
}

.modal-dialog {
  max-width: 700px;
  margin: 1.75rem auto;
}

.showHistoryClass div.modal-dialog {
  width: 100% !important;
  max-width: 700px;
}`, "",{"version":3,"sources":["webpack://./src/app/salespeople/modals/showruleadjustmenthistory.screen.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEE;EACE,SAAA;AACJ;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AACF;;AAGI;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;AAAN;AAKM;EACE,mBAAA;AAHR;;AAQA;EACE,gBAAA;EACA,oBAAA;AALF;;AAOA;EACC,sBAAA;EACG,gBAAA;AAJJ","sourcesContent":["div.modal-dialog {\n  max-width: 700px !important;\n}\n#striped-light {\n  .card {\n    margin: 0;\n  }\n}\nform .col-form-label {\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.table {\n  thead {\n    th {\n      background: transparent;\n      color: #586562;\n      border-top: none;\n    }\n  }\n  tbody {\n    tr {\n      &:hover {\n        background: #e4f1fa;\n      }\n    }\n  }\n}\n.modal-dialog {\n  max-width: 700px;\n  margin: 1.75rem auto;\n}\n.showHistoryClass div.modal-dialog  {\n\twidth: 100% !important;\n    max-width: 700px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
